module.exports = __webpack_public_path__ + "img/title.1b55c0e9.png";